import axios from '@/services/api'

export const postRatings = (data) => {
	const url = `/api/ratings`
	return axios.post(url, data)
}
